export default {
  computed: {
    more() {
      return this.$route.name.startsWith('more');
    },
  },
  methods: {
    /**
     * Load script.
     *
     * @param {String} src
     *
     * @return {Promise}
     */
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.onload = () => resolve();
        script.onerror = () => reject();
        script.src = src;
        script.async = false;
        document.head.appendChild(script);
      });
    },
  },
};
